import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiAccordion = {
  styleOverrides: {
    root: ({ theme }) => {
      const isDark = theme.palette.mode === 'dark';
      return {
        borderRadius: '12px !important',
        backgroundImage: 'none',
        overflow: 'hidden',
        '&:before': { display: 'none' },
        ...(isDark && {
          backgroundColor: 'var(--mui-palette-neutral-900) !important',
          border: '1px solid rgba(255, 255, 255, 0.06)',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.35)',
        }),
      };
    },
  },
} satisfies Components<Theme>['MuiAccordion'];

export const MuiAccordionSummary = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...(theme.palette.mode === 'dark' && {
        backgroundColor: 'var(--mui-palette-neutral-900)',
        color: 'var(--mui-palette-text-primary)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
      }),
    }),
    content: ({ theme }) => ({
      ...(theme.palette.mode === 'dark' && {
        color: 'var(--mui-palette-text-primary)',
      }),
    }),
    expandIconWrapper: {
      color: 'var(--mui-palette-text-secondary)',
    },
  },
} satisfies Components<Theme>['MuiAccordionSummary'];

export const MuiAccordionDetails = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...(theme.palette.mode === 'dark' && {
        backgroundColor: 'var(--mui-palette-neutral-900)',
        color: 'var(--mui-palette-text-primary)',
      }),
    }),
  },
} satisfies Components<Theme>['MuiAccordionDetails'];
